
function resetCartQuantities() {
  // Iterate over each key in the window.productMetaData object
  for (let key in window.productMetaData) {
    // Check if the property is an object and has a cartQuantity property
    if (window.productMetaData[key] instanceof Object && window.productMetaData[key].hasOwnProperty('cartQuantity')) {
      // Set cartQuantity to 0
      window.productMetaData[key].cartQuantity = 0;
    }
  }
}

function updateMetaDataWithCartData() {
  resetCartQuantities()
    
  if (window.shopifyCart && window.shopifyCart.items && window.shopifyCart.items.length > 0) {
    window.shopifyCart.items.forEach(cartItem => {
        // Check if this cartItem's ID exists in window.productMetaData
        if (window.productMetaData.hasOwnProperty(cartItem.id)) {
            // Assuming you want to add the quantity of the cart item to window.productMetaData
            window.productMetaData[cartItem.id].cartQuantity = cartItem.quantity;
        }
    });
  } 
}


function getShopifyCart() {
// Making a GET request to /cart.js
fetch('/cart.js')
  .then(response => {
      // Check if the response is ok (status 200)
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      // Parse the JSON response
      return response.json();
  })
  .then(cart => {
      // You can now assign this to a global variable or use it directly
    window.shopifyCart = cart;
    updateMetaDataWithCartData();
  })
  .catch(error => {
      // Handle any errors
      console.error('There was a problem with the fetch operation:', error);
  });
}

function resetMetaData(cart) {
  resetCartQuantities()
        
  if (cart && cart.items && cart.items.length > 0) {
      cart.items.forEach(cartItem => {
          // Check if this cartItem's ID exists in metaData
          if (window.productMetaData.hasOwnProperty(cartItem.id)) {
              // Assuming you want to add the quantity of the cart item to metaData
              window.productMetaData[cartItem.id].cartQuantity = cartItem.quantity;
          }
      });
  } 
    
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.productMetadata == false) return 
  getShopifyCart()
  document.addEventListener('queueComplete', () => {
      resetMetaData(CartJS.cart)
  })
})

